import { ProductName } from "../interfaces"

// 上限まわりの「数値だけ通す」口。TeamQuota 側と Plan 側で同じ硬さにするため共有する。
// Number() 任せにすると "" と [] が 0（= 上限 0）に、"abc" と {} が NaN
// （画面に NaN が出る）になり、どちらも「上限」として通ってしまう。
export const toNumberOrNull = (value: unknown): number | null => {
  if (typeof value === "number") return Number.isFinite(value) ? value : null
  if (typeof value !== "string" || value.trim() === "") return null

  const num = Number(value)

  return Number.isFinite(num) ? num : null
}

// 真偽値だけ通す。"false" や 0 を JS の真偽値として読むと、エンフォースしない側
// （無制限）に倒れてしまうため、文字列も数値も受け付けない。
export const isTrue = (value: unknown): boolean => value === true

export const BYTES_PER_GB = 1024 * 1024 * 1024

// bandwidth だけ auth-api がバイトで返す（`Billing::Catalog::UNIT_SIZES` は
// 1 単位 = 10 GB、`StripeSubscriptionItemSerializer` は included / purchased の
// どちらも `values[...].to_i` で換算しない）。画面は GB で描くので、
// **プラン上限（included_quota）も単体追加分（purchased_quota）も必ずここを通す。**
// 片方だけ通すと、同じ行に 2 つの単位が並んで `5 (+42949672960)GB` になる。
//
// MEMO: 1GiB 未満は 0 になる。購入の単位が 10 GB なので単体追加分では当たらない。
export const toGigabytes = (value: number, productName: ProductName): number =>
  productName === "bandwidth" ? Math.floor(value / BYTES_PER_GB) : value
